import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { PageContentStore } from './page-content.store';

@Injectable({
  providedIn: 'root'
})
export class PageContentQuery extends BaseQuery {

  constructor(store: PageContentStore) {
    super(store);
  }


}
